import axios from 'axios'

export default axios.create({
    baseURL: 'https://api.box24corp.com/rest/index.php/v1/3rdparty'
})
